import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { EmojiSelectorComponent } from './emoji-selector.component.js';
import { CardModule } from '../card/index.js';
import { AppFlexModule } from '../flex/index.js';

@NgModule({
	imports: [CommonModule, CardModule, AppFlexModule],
	declarations: [EmojiSelectorComponent],
	exports: [EmojiSelectorComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EmojiModule {}
